import { distinctUntilChanged, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getFilteredViewedProducts, getOperationCode, getUri } from 'store/selectors'
import { getPageNameFromUri } from 'domain/router'
import { disableMixPanelTracking } from '../disable'

export const mapStateToMPEvent = (eventName, state, { externalId, title, hasStock, price, position }) => ({ // (eventName: string, state: State, { externalId, title, hasStock, price, position }: ProductSelection)
  '# of Recently Viewed Product Displayed': getFilteredViewedProducts(state).length,
  'Click Name': 'Click Recently Products Viewed Thumbnail',
  'Cross-Sell Type': 'Recently Viewed Product',
  'Event Name': eventName,
  'Interaction Type': 'Click',
  'Lowest Price': price,
  'Operation Code': getOperationCode(state),
  'Page Name': getPageNameFromUri(getUri(state)),
  'Product': title,
  'Product ID': externalId,
  'Product Position': position,
  'Stock Status': (!hasStock) ? 'Sold out' : 'Available'
})

const viewedProductEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.resources.VIEWED_PRODUCT_SELECTION),
  distinctUntilChanged(),
  tap((action) => { // (action: ViewedProductSelectionAction)
    const eventName = 'Click Cross-Sell Thumbnail'

    track(eventName, mapStateToMPEvent(eventName, state$.value, action.payload), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default viewedProductEpic
